<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title>{{'test.updateTest.heading' | translate}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
      <button mat-icon-button mat-dialog-close aria-label="Close Dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <mat-dialog-content class="mat-typography">
    <form [formGroup]="testDetailsForm" novalidate>
      <div class="form-wrapper">
        <div class="input-wrapper">
          <span class="input-label">
            <label>{{'test.updateTest.labelName' | translate}}</label><span class="required">*</span>
          </span>
          <span class="input-field">
            <textarea class="form-control textarea" rows="2" maxlength="121" type="text" formControlName="testTitle"
              [readonly]='isPublished'></textarea>
            <div *ngIf="f.testTitle.invalid && (f.testTitle.dirty || f.testTitle.touched) && !f.testTitle.errors?.whitespace" class="alert alert-danger">
              <div *ngIf="f.testTitle.errors?.required">{{'test.updateTest.nameError1' | translate}}</div>
              <div *ngIf="f.testTitle.errors?.minlength">{{'test.updateTest.nameError2' | translate}}</div>
              <div *ngIf="f.testTitle.errors?.maxlength">{{'test.updateTest.nameError3' | translate}}</div>
              <div *ngIf="f.testTitle.errors?.pattern">{{'test.updateTest.nameError4' | translate}}</div>
            </div>
          </span>
        </div>
        <div class="input-wrapper">
          <span class="input-label">
            <label>{{'test.updateTest.labelDesc' | translate}}</label>
          </span>
          <span class="input-field">
            <textarea type="text" rows="8" maxlength="481" class="form-control textarea" type="text" formControlName="testDescription"
              [readonly]='isPublished'></textarea>
            <div *ngIf="f.testDescription.invalid && (f.testDescription.dirty || f.testDescription.touched)" class="alert alert-danger">
              <div *ngIf="f.testDescription.errors?.minlength">{{'test.updateTest.descError1' | translate}}</div>
              <div *ngIf="f.testDescription.errors?.maxlength">{{'test.updateTest.descError2' | translate}}</div>

            </div>
          </span>
        </div>
        <div class="input-wrapper">
          <div class="input-label">
            <label>{{'items.NewItem.scoringType' | translate}} <span class="required">*</span></label>
          </div>
          <div class="input-field">
            <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid"
              ng-reflect-model="" formControlName="scoringTypeId" [(ngModel)]="selectedScoringType"
              (change)="changeScoringType(selectedScoringType)" [attr.disabled]="itemsCount">
              <option *ngFor="let option of scoringTypes" [value]="option?.scoringTypeId" >
                {{option?.scoringTypeName}}
              </option>
            </select>
          </div>
        </div>

        <div class="input-wrapper" *ngIf="isStyleGroupShow">
          <div class="input-label">
            <label>{{'items.NewItem.styleGroup' | translate}} <span class="required">*</span></label>
          </div>
          <div class="input-field">
            <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid" [attr.disabled]="itemsCount"
                ng-reflect-model="" formControlName="styleGroupId" [(ngModel)]="selectedstyleGroup">
                <option *ngFor="let option of styleGroupData" [value]="option?.styleGroupId">
                  {{option?.styleGroupName}}
                </option>
              </select>
          </div>
          <div *ngIf="f.styleGroupId.invalid && (f.styleGroupId.touched)" class="alert alert-danger">
            <div *ngIf="f.styleGroupId.errors?.required">{{'items.NewItem.styleGroupError1' | translate}} </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <!-- <button mat-flat-button color="" class="btn-primary" aria-label="Save"  (click)='editBasicTestDetails()'
      [disabled]="isPublished || testDetailsForm.invalid">Save</button> -->
    <button mat-flat-button color="" class="btn-primary" aria-label="Save" (click)='editBasicTestDetails()'
      [disabled]="(isPublished || f.testTitle.invalid || f.testDescription.invalid || f.scoringTypeId.invalid || f.styleGroupId.invalid)">{{'test.updateTest.btnSave' | translate}}</button>
  </mat-dialog-actions>
</div>

<!-- <div class="main-div">
    <div class="col-md-10 text-center" [ngClass]="{'text-success': success,'text-danger': error}" *ngIf="messageFlag">{{messages}}</div>
    <div class="btn-wrapper">
        <button (click)='editBasicTestDetails()' mat-raised-button class="btn-bg-color"
            [disabled]="isPublished || testDetailsForm.invalid">Save</button>
    </div>
    <div class="frm-container">
        <form [formGroup]="testDetailsForm">
            <div class="input-class">
                <label>Test name<span class="red-asterisk">*</span></label>
                <input class="form-control" maxlength="121" type="text" formControlName="testTitle" [readonly]='isPublished'>
                <div *ngIf="f.testTitle.invalid && (f.testTitle.dirty || f.testTitle.touched)" class="alert alert-danger">
                    <div *ngIf="f.testTitle.errors?.required"> Test name is required. </div>
                    <div *ngIf="f.testTitle.errors?.minlength">Minimum 3 characters required. </div>
                    <div *ngIf="f.testTitle.errors?.maxlength"> Maximum 120 characters allowed. </div>
                </div>
            </div>
            <div class="input-class">
                <label>Test description</label>
                <textarea type="text" maxlength="481" class="form-control textarea" type="text" formControlName="testDescription" [readonly]='isPublished'></textarea>
                <div *ngIf="f.testDescription.invalid && (f.testDescription.dirty || f.testDescription.touched)" class="alert alert-danger">
                    <div *ngIf="f.testDescription.errors?.minlength"> Minimum 20 characters required. </div>
                    <div *ngIf="f.testDescription.errors?.maxlength"> Maximum 480 characters allowed. </div>
                </div>
            </div>
        </form>
    </div>
    </div> -->








<!-- <div class="filter-section title"> Details</div> -->
<!-- <div class="main-div">
<div class="col-md-10 text-center" [ngClass]="{'text-success': success,'text-danger': error}" *ngIf="messageFlag">{{messages}}</div>
<div class="btn-wrapper">
    <button (click)='editBasicTestDetails()' mat-raised-button class="btn-bg-color"
        [disabled]="isPublished || testDetailsForm.invalid">Save</button>
</div>
<div class="frm-container">
    <form [formGroup]="testDetailsForm">
        <div class="input-class">
            <label>Test name<span class="red-asterisk">*</span></label>
            <input class="form-control" maxlength="121" type="text" formControlName="testTitle" [readonly]='isPublished'>
            <div *ngIf="f.testTitle.invalid && (f.testTitle.dirty || f.testTitle.touched)" class="alert alert-danger">
                <div *ngIf="f.testTitle.errors?.required"> Test name is required. </div>
                <div *ngIf="f.testTitle.errors?.minlength">Minimum 3 characters required. </div>
                <div *ngIf="f.testTitle.errors?.maxlength"> Maximum 120 characters allowed. </div>
            </div>
        </div>
        <div class="input-class">
            <label>Test description</label>
            <textarea type="text" maxlength="481" class="form-control textarea" type="text" formControlName="testDescription" [readonly]='isPublished'></textarea>
            <div *ngIf="f.testDescription.invalid && (f.testDescription.dirty || f.testDescription.touched)" class="alert alert-danger">
                <div *ngIf="f.testDescription.errors?.minlength"> Minimum 20 characters required. </div>
                <div *ngIf="f.testDescription.errors?.maxlength"> Maximum 480 characters allowed. </div>
            </div>
        </div>
    </form>
</div>
</div> -->

<!-- <div class="filter-section title">Basic Details</div>
<div class="btn-wrapper">
    <button (click)='saveBasicItemDetails()' mat-raised-button class="btn-bg-color" [disabled]="isPublished">Save</button>
</div>
<div class="frm-container">
    <div class="input-class">
        <label>Test Name</label>
        <input class="form-control" type="text" [(ngModel)]='itemBasicDetails.testTitle'>
      </div>
      <div class="input-class">
          <label>Test Description</label>
          <input class="form-control" type="text" [(ngModel)]='itemBasicDetails.testDescription'>
      </div>
</div> -->
